var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface123571504"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    style: {
      fill: "rgb(81.176472%,88.235295%,96.862745%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.647059%,90.196079%,36.078432%)",
      fillOpacity: 1
    },
    d: "M 84.46875 44 L 50 44 L 50 57 L 70.855469 57 C 67.929688 65.71875 59.703125 72 50 72 C 37.851562 72 28 62.148438 28 50 C 28 37.851562 37.851562 28 50 28 C 54.800781 28 59.234375 29.539062 62.851562 32.148438 L 72.121094 22.878906 C 66.089844 17.957031 58.390625 15 50 15 C 30.671875 15 15 30.671875 15 50 C 15 69.328125 30.671875 85 50 85 C 69.328125 85 85 69.328125 85 50 C 85 47.953125 84.804688 45.949219 84.46875 44 Z M 84.46875 44 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,63.529414%,82.352942%)",
      fillOpacity: 1
    },
    d: "M 50 57 L 70.855469 57 C 69.277344 61.699219 66.152344 65.679688 62.09375 68.359375 L 71.964844 77.242188 C 79.910156 70.828125 85 61.011719 85 50 C 85 47.953125 84.804688 45.949219 84.46875 44 L 50 44 Z M 50 57 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(37.64706%,74.509805%,57.254905%)",
      fillOpacity: 1
    },
    d: "M 62.09375 68.359375 C 58.621094 70.652344 54.472656 72 50 72 C 41.003906 72 33.273438 66.597656 29.863281 58.859375 L 18.816406 65.890625 C 24.609375 77.230469 36.394531 85 50 85 C 58.320312 85 65.957031 82.09375 71.964844 77.242188 Z M 62.09375 68.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.509804%,35.686275%,42.352942%)",
      fillOpacity: 1
    },
    d: "M 29.675781 41.570312 C 32.984375 33.601562 40.835938 28 50 28 C 54.800781 28 59.234375 29.539062 62.851562 32.148438 L 72.121094 22.878906 C 66.089844 17.957031 58.390625 15 50 15 C 36.226562 15 24.320312 22.957031 18.605469 34.523438 Z M 29.675781 41.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 50 86 C 30.148438 86 14 69.851562 14 50 C 14 30.148438 30.148438 14 50 14 C 58.269531 14 66.351562 16.878906 72.753906 22.105469 C 72.972656 22.285156 73.105469 22.546875 73.117188 22.828125 C 73.132812 23.109375 73.027344 23.386719 72.828125 23.585938 L 63.558594 32.855469 C 63.210938 33.203125 62.664062 33.246094 62.265625 32.960938 C 58.675781 30.367188 54.433594 29 50 29 C 38.421875 29 29 38.421875 29 50 C 29 61.578125 38.421875 71 50 71 C 58.5625 71 66.195312 65.832031 69.417969 58 L 50 58 C 49.445312 58 49 57.550781 49 57 L 49 44 C 49 43.449219 49.445312 43 50 43 L 84.46875 43 C 84.953125 43 85.367188 43.351562 85.453125 43.828125 C 85.816406 45.921875 86 48 86 50 C 86 69.851562 69.851562 86 50 86 Z M 50 16 C 31.253906 16 16 31.253906 16 50 C 16 68.746094 31.253906 84 50 84 C 68.746094 84 84 68.746094 84 50 C 84 48.375 83.871094 46.699219 83.617188 45 L 51 45 L 51 56 L 70.855469 56 C 71.179688 56 71.480469 56.15625 71.667969 56.414062 C 71.855469 56.675781 71.90625 57.011719 71.804688 57.316406 C 68.65625 66.699219 59.894531 73 50 73 C 37.316406 73 27 62.683594 27 50 C 27 37.316406 37.316406 27 50 27 C 54.570312 27 58.953125 28.328125 62.734375 30.851562 L 70.617188 22.96875 C 64.71875 18.46875 57.441406 16 50 16 Z M 50 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 71.5 78 C 71.382812 78 71.261719 77.957031 71.164062 77.871094 L 67.164062 74.273438 C 66.960938 74.085938 66.941406 73.769531 67.128906 73.566406 C 67.316406 73.359375 67.628906 73.34375 67.835938 73.527344 L 71.835938 77.128906 C 72.039062 77.3125 72.058594 77.628906 71.871094 77.835938 C 71.773438 77.945312 71.636719 78 71.5 78 Z M 71.5 78 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 65.5 72.601562 C 65.382812 72.601562 65.261719 72.558594 65.164062 72.472656 L 63.386719 70.871094 C 63.183594 70.6875 63.164062 70.371094 63.351562 70.164062 C 63.539062 69.960938 63.851562 69.945312 64.058594 70.128906 L 65.835938 71.730469 C 66.039062 71.914062 66.058594 72.230469 65.871094 72.433594 C 65.773438 72.542969 65.636719 72.601562 65.5 72.601562 Z M 65.5 72.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 27.929688 60 C 27.765625 60 27.601562 59.917969 27.507812 59.769531 C 27.359375 59.535156 27.429688 59.226562 27.660156 59.078125 L 29.230469 58.078125 C 29.460938 57.933594 29.773438 58 29.921875 58.230469 C 30.070312 58.464844 30 58.773438 29.769531 58.921875 L 28.195312 59.921875 C 28.113281 59.976562 28.019531 60 27.929688 60 Z M 27.929688 60 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 23.5 62.816406 C 23.335938 62.816406 23.175781 62.734375 23.078125 62.585938 C 22.929688 62.355469 23 62.046875 23.230469 61.898438 L 25.230469 60.625 C 25.460938 60.476562 25.773438 60.542969 25.921875 60.777344 C 26.070312 61.011719 26 61.320312 25.769531 61.46875 L 23.769531 62.738281 C 23.6875 62.792969 23.59375 62.816406 23.5 62.816406 Z M 23.5 62.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 18.5 66 C 18.335938 66 18.175781 65.917969 18.078125 65.769531 C 17.929688 65.535156 18 65.226562 18.230469 65.078125 L 21.230469 63.171875 C 21.460938 63.023438 21.773438 63.089844 21.921875 63.324219 C 22.070312 63.554688 22 63.863281 21.769531 64.011719 L 18.769531 65.921875 C 18.6875 65.976562 18.59375 66 18.5 66 Z M 18.5 66 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 24.5 38.183594 C 24.40625 38.183594 24.3125 38.15625 24.230469 38.105469 L 19.230469 34.921875 C 19 34.773438 18.929688 34.464844 19.078125 34.230469 C 19.226562 34 19.539062 33.933594 19.769531 34.078125 L 24.769531 37.261719 C 25 37.410156 25.070312 37.71875 24.921875 37.949219 C 24.824219 38.101562 24.664062 38.183594 24.5 38.183594 Z M 24.5 38.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(12.156863%,12.941177%,16.862746%)",
      fillOpacity: 1
    },
    d: "M 27.5 40.089844 C 27.40625 40.089844 27.3125 40.066406 27.230469 40.011719 L 26.230469 39.378906 C 26 39.230469 25.929688 38.917969 26.078125 38.6875 C 26.226562 38.453125 26.539062 38.386719 26.769531 38.535156 L 27.769531 39.171875 C 28 39.316406 28.070312 39.628906 27.921875 39.859375 C 27.824219 40.007812 27.664062 40.089844 27.5 40.089844 Z M 27.5 40.089844 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.48aeaf13.svg";
export { ForwardRef as ReactComponent };